export enum ApiErrorCodes {
  UnprocessableEntity = 422,
  NotFound = 404
}
